"use client";

import { LazySearchProductsError } from "@faire/retailer-visitor-shared/components/SearchProducts/SearchProductsError/index";
import { SearchPageLogErrorEffect } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageEffects/SearchPageLogErrorEffect";
import { useSearchPageIsError } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageIsError";
import React, { ReactNode, Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

export const WithSearchPageErrorBoundary = ({
  children,
}: {
  children: ReactNode;
}) => {
  return (
    <ErrorBoundary fallbackRender={SearchPageErrorHandler}>
      {children}
      <SearchPageErrorListener />
    </ErrorBoundary>
  );
};

// An adapter to use ErrorBoundary with Suspense when .error from context is true
const SearchPageErrorListener = () => {
  const isError = useSearchPageIsError();
  if (isError) {
    // delegate error to ErrorBoundary
    throw new Error("SearchPageError");
  }
  return null;
};

export const SearchPageErrorHandler = () => {
  return (
    <>
      <SearchPageLogErrorEffect />
      <Suspense fallback={null}>
        <LazySearchProductsError />
      </Suspense>
    </>
  );
};
